(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    var desktopQuery = window.matchMedia('(min-width: 990px)');
    var CLOSE_DELAY = 150; // ms — flicker rokne ke liye thoda delay

    function initHoverMenus() {
      document.querySelectorAll('header-menu.header-menu--hover').forEach(function (menu) {
        if (menu.dataset.hoverInit === 'true') return; // duplicate binding se bachne ke liye
        menu.dataset.hoverInit = 'true';

        var details = menu.querySelector(':scope > details');
        if (!details) return;
        var summary = details.querySelector(':scope > summary');
        var closeTimeout;

        // TOP-LEVEL menu: hover se open/close
        menu.addEventListener('mouseenter', function () {
          if (!desktopQuery.matches) return;
          clearTimeout(closeTimeout);
          details.setAttribute('open', '');
        });

        menu.addEventListener('mouseleave', function () {
          if (!desktopQuery.matches) return;
          closeTimeout = setTimeout(function () {
            details.removeAttribute('open');
          }, CLOSE_DELAY);
        });

        // Click handling:
        // - Agar click summary ke andar wali <a href> link par hua hai -> usko normally navigate hone do
        // - Warna (caret/padding area) -> desktop pe default toggle-behavior block karo (hover already control karta hai)
        summary.addEventListener('click', function (e) {
          var clickedLink = e.target.closest('a[href]');
          if (clickedLink) {
            // link ko navigate hone do, kuch mat karo
            return;
          }
          if (desktopQuery.matches && matchMedia('(hover: hover)').matches) {
            e.preventDefault();
          }
        });

        // NESTED submenu (2nd/3rd level <details>) ke liye bhi wahi hover + click-link logic
        details.querySelectorAll('li').forEach(function (li) {
          var subDetails = li.querySelector(':scope > details');
          if (!subDetails) return;
          var subSummary = subDetails.querySelector(':scope > summary');
          var subCloseTimeout;

          li.addEventListener('mouseenter', function (e) {
            if (!desktopQuery.matches) return;
            e.stopPropagation();
            clearTimeout(subCloseTimeout);
            subDetails.setAttribute('open', '');
          });

          li.addEventListener('mouseleave', function (e) {
            if (!desktopQuery.matches) return;
            e.stopPropagation();
            subCloseTimeout = setTimeout(function () {
              subDetails.removeAttribute('open');
            }, CLOSE_DELAY);
          });

          subSummary.addEventListener('click', function (e) {
            var clickedLink = e.target.closest('a[href]');
            if (clickedLink) {
              return;
            }
            if (desktopQuery.matches && matchMedia('(hover: hover)').matches) {
              e.preventDefault();
            }
          });
        });

        // Menu se bahar click karne pe close ho jaye
        document.addEventListener('click', function (e) {
          if (!details.hasAttribute('open')) return;
          if (!menu.contains(e.target)) {
            details.removeAttribute('open');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHoverMenus);
    } else {
      initHoverMenus();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
